import ReportScreen from './components/ReportScreen'

export default {
  path: '/reporta/:slug',
  name: 'Report',
  component: ReportScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Report/index.js